// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bottomSlide":"bottomSlide-1rO8cSxW","activityBox":"activityBox-Lzms_KBL","activityImage":"activityImage-dnL5RR8v"};